import { Link, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import { NavLink } from "components/navigation/NavLink";

interface Props {
  uuid: string;
}

export function SelectMeasureFooter(props: Props) {
  const { uuid } = props;
  const { t } = useTranslation();

  return (
    <StyledPaper elevation={0}>
      <Link component={NavLink} to={`/${uuid}/measures`}>
        {t("label.cancel")}
      </Link>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`;
